import {
  CompassAPIMultiSeriesChartData,
  getCompassAPIChartData,
  getMultipleLineChartProps,
} from '../utils/compass'
import type { BaseContext } from './'
import { CommonChartConfig } from './common'

export namespace Retail {
  export namespace Valuation {
    const CONTEXT_ID = 'equity:retail:valuation'

    export const __typelist: {
      config: ChartConfig
      data: ChartData
      context: ContextType
    } = {} as any

    export type ContextType = BaseContext<
      typeof CONTEXT_ID,
      ChartConfig,
      ChartData
    >

    export interface ChartConfig extends CommonChartConfig {
      chart:
        | 'pe_asai3_bz'
        | 'pe_crfb3_bz'
        | 'pe_gmat3_bz'
        | 'pe_pcar3_bz'
        | 'pe_radl3_bz'
        | 'pe_pgmn3_bz'
        | 'pe_pnvl3_bz'
      context: typeof CONTEXT_ID
      title: string
    }

    export type ChartData = CompassAPIMultiSeriesChartData

    export const Context: ContextType = {
      id: CONTEXT_ID,
      getChartId: (config) => `${config.context}:${config.chart}`,
      getChartData: getCompassAPIChartData,
      getChartProps: (config, data) =>
        getMultipleLineChartProps(Context, {
          addMinMaxIndicators: true,
          chartTitle: config.title,
          msdIndicators: { avg: true, sd1: true, sd2: true },
        }, { name: [''] })(config, data),
    }
  }
}
